import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const FileTypeXlsxIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.49444 13.8576C9.613 14.7454 14.7317 14.7155 19.8502 13.8576V6.7415C19.8502 6.66042 19.824 6.58159 19.7753 6.51678L16.4046 2.0224C16.3338 1.92811 16.2228 1.87256 16.105 1.87256H5.61804C5.32006 1.87256 5.03422 1.99094 4.82352 2.20164C4.61282 2.41242 4.49444 2.69818 4.49444 2.99615V11.6104C4.49444 12.1667 4.36401 12.6381 4.36401 13.014C4.36401 13.5335 4.49444 13.8576 4.49444 13.8576Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.24719 12.8867V20.9737C2.24719 21.2716 2.36557 21.5575 2.57627 21.7682C2.78697 21.9789 3.07281 22.0973 3.37079 22.0973H20.5993C20.8973 22.0973 21.183 21.9789 21.3938 21.7682C21.6045 21.5575 21.7229 21.2716 21.7229 20.9737C21.7229 19.5385 21.7229 16.4164 21.7229 14.9812C21.7229 14.6832 21.6045 14.3974 21.3938 14.1867C21.183 13.976 20.8973 13.8576 20.5993 13.8576H3.74535C3.26751 13.8576 2.24719 12.8867 2.24719 12.8867Z"
      fill="#1FB35B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.37079 13.8577C3.02886 13.8577 2.77924 13.719 2.59551 13.5482C2.42265 13.3875 2.24719 13.1042 2.24719 12.7341C2.24719 12.4965 2.36557 12.1502 2.57627 11.9396C2.78697 11.7289 3.07281 11.6105 3.37079 11.6105H4.49438V13.8577C4.49438 13.8577 4.59065 13.8577 3.37079 13.8577Z"
      fill="#198043"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M11.6105 12.3595V8.98871H6.74158V11.9849C6.74158 12.1919 6.90922 12.3595 7.11614 12.3595H11.6105Z"
      fill="#1FB35B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M11.6105 4.8689H7.11614C6.90922 4.8689 6.74158 5.03654 6.74158 5.24337V8.23968H11.6105V4.8689Z"
      fill="#1FB35B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17.2284 8.98871H12.3595V12.3595H16.8539C17.0607 12.3595 17.2284 12.1919 17.2284 11.9849V8.98871Z"
      fill="#1FB35B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.1048 4.8689H12.3595V8.23968H17.2284V6.74153C17.2284 6.53478 17.0606 6.36696 16.8539 6.36696C16.6471 6.36696 16.4793 5.45011 16.4793 5.24337C16.4793 5.03672 16.3115 4.8689 16.1048 4.8689Z"
      fill="#1FB35B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M8.75464 16.1048V19.8501C8.75464 20.057 8.92228 20.2247 9.1292 20.2247H11.47C11.6767 20.2247 11.8445 20.0568 11.8445 19.8501C11.8445 19.6435 11.6767 19.4756 11.47 19.4756H9.50367V16.1048C9.50367 15.8981 9.33585 15.7303 9.1292 15.7303C8.92246 15.7303 8.75464 15.8981 8.75464 16.1048Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.2463 20.0967L19.5234 16.3514C19.6596 16.1959 19.6438 15.959 19.4882 15.8229C19.3327 15.6869 19.0958 15.7026 18.9597 15.8582L15.6825 19.6035C15.5464 19.759 15.5623 19.9959 15.7178 20.132C15.8734 20.2681 16.1102 20.2523 16.2463 20.0967Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M5.01035 20.0967L8.28747 16.3514C8.42365 16.1959 8.40783 15.959 8.25223 15.8229C8.09673 15.6869 7.85988 15.7026 7.72379 15.8582L4.44657 19.6035C4.31048 19.759 4.3263 19.9959 4.48181 20.132C4.6374 20.2681 4.87426 20.2523 5.01035 20.0967Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M19.5234 19.6035L16.2463 15.8582C16.1102 15.7026 15.8734 15.6869 15.7178 15.8229C15.5623 15.959 15.5464 16.1959 15.6825 16.3514L18.9597 20.0967C19.0958 20.2523 19.3327 20.2681 19.4882 20.132C19.6438 19.9959 19.6596 19.759 19.5234 19.6035Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M8.28747 19.6035L5.01035 15.8582C4.87426 15.7026 4.6374 15.6869 4.48181 15.8229C4.3263 15.959 4.31048 16.1959 4.44657 16.3514L7.72379 20.0967C7.85988 20.2523 8.09673 20.2681 8.25223 20.132C8.40783 19.9959 8.42365 19.759 8.28747 19.6035Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.0319 18.9162L12.0319 18.9161V19.1018C12.0319 19.3996 12.1502 19.6853 12.3608 19.8958C12.5714 20.1064 12.8569 20.2247 13.1547 20.2247H13.9989C14.2967 20.2247 14.5823 20.1064 14.7928 19.8958C15.0035 19.6853 15.1217 19.3996 15.1217 19.1018C15.1217 19.0515 15.1217 19.0015 15.1217 18.9528C15.1217 18.4933 14.842 18.0802 14.4155 17.9095L13.0536 17.3648C12.8889 17.2989 12.7809 17.1395 12.7809 16.9621V16.8539C12.7809 16.7546 12.8204 16.6593 12.8906 16.5891C12.9608 16.5188 13.0561 16.4793 13.1555 16.4793H13.9982C14.0975 16.4793 14.1928 16.5188 14.263 16.5891C14.3333 16.6593 14.3727 16.7546 14.3727 16.8539V17.0389C14.3727 17.1446 14.4195 17.2402 14.4664 17.2888C14.5395 17.3717 14.6445 17.4157 14.7472 17.4157C14.9296 17.4157 15.1217 17.2749 15.1217 17.0389V16.8539C15.1217 16.5559 15.0034 16.2701 14.7927 16.0594C14.582 15.8487 14.2961 15.7303 13.9982 15.7303H13.1555C12.8575 15.7303 12.5716 15.8487 12.3609 16.0594C12.1502 16.2701 12.0319 16.5559 12.0319 16.8539V16.9621C12.0319 17.4457 12.3263 17.8807 12.7754 18.0603L14.1373 18.6051C14.2795 18.6619 14.3727 18.7997 14.3727 18.9528V19.1018C14.3727 19.2009 14.3333 19.296 14.2632 19.3662C14.1931 19.4363 14.098 19.4756 13.9989 19.4756H13.1547C13.0556 19.4756 12.9605 19.4363 12.8904 19.3662C12.8204 19.296 12.781 19.2009 12.781 19.1019C12.7809 19.1018 12.7809 19.1018 12.7809 18.9161C12.7809 18.6691 12.5796 18.5391 12.413 18.5391C12.255 18.5391 12.0319 18.6616 12.0319 18.9138C12.0319 18.9162 12.0319 18.9162 12.0319 18.9162Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.1049 1.87256V5.61791C16.1049 5.91588 16.2232 6.20173 16.4339 6.41242C16.6446 6.62312 16.9304 6.7415 17.2285 6.7415H19.8501C19.8501 6.66042 19.8239 6.58159 19.7752 6.51678L16.4045 2.0224C16.3337 1.92811 16.2227 1.87256 16.1049 1.87256Z"
      fill="#AFBDC7"
      fillRule="evenodd"
    />
  </svg>
);

export default FileTypeXlsxIcon;
